import { reduxKey } from './constants';
function getEditorState(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey];
}
export function isAnyEditorFocused(state) {
    var editors = getEditorState(state);
    return Object.keys(editors).some(function (key) { return editors[key].isActive; });
}
export function isEditorFocused(state, editorKey) {
    var editors = getEditorState(state);
    return editors[editorKey] && editors[editorKey].isActive;
}
//# sourceMappingURL=selectors.js.map